<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <div class="card-body text-center">
      <div class="card-title text-center">
        <h3>Stand service</h3>
      </div>
      <form @submit.prevent>
        <div class="form-group text-left">
          <label for="">Before picture</label>
          <div>
            <a v-on:click='takePicture(["standService", "beforePictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{standService.beforePictures.length}}</badge>
            <p v-if="showErrorPicturesBefore"><span class="errorimagesquantity">Min 1 picture required</span></p>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="emptyPockets">Empty pockets</label>
          <base-input class="mb-3"
                      id="emptyPockets"
                      required='required'
                      placeholder=""
                      name='emptyPockets'
                      v-model="standService.emptyPockets"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('emptyPockets')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="filledPockets">Filled pockets</label>
          <base-input class="mb-3"
                      id="filledPockets"
                      required='required'
                      placeholder=""
                      name='filledPockets'
                      v-model="standService.filledPockets"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('filledPockets')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="cleanedStand">Stand cleaned</label>
          <select class="form-control" :class="{'is-invalid': vErrors.first('cleanedStand') }"
            name="cleanedStand"
            v-model="standService.cleanedStand"
            id="cleanedStand"
            v-validate="'required'"
            data-vv-validate-on="blur">
            <option value="" disabled></option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('cleanedStand') }}</span>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="">After picture</label>
          <div>
            <a v-on:click='takePicture(["standService", "afterPictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{standService.afterPictures.length}}</badge>
            <p v-if="showErrorPicturesAfter"><span class="errorimagesquantity">Min 1 picture required</span></p>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="">Wide angle picture</label>
          <div>
            <a v-on:click='takePicture(["standService", "wideAnglePictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{standService.wideAnglePictures.length}}</badge>
            <p v-if="showErrorPicturesWideAngle"><span class="errorimagesquantity">Min 1 picture required</span></p>
          </div>
        </div>
        <div class="form-group text-left mb-3">
          <label for="serviceNotes">Service Notes</label>
          <textarea class="form-control"
                    id="serviceNotes"
                    v-model="standService.serviceNotes"
                    name="serviceNotes"
                    rows="3">
          </textarea>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="standService.newDelivered">
            Whats new delivered
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="standService.headerInstallation">
            Header Installation
          </base-checkbox>
        </div>
        <div v-if="isTestFunctions">
          <div class="form-group text-left">
            <label for="headerCapable">Digital Header capable</label>
            <select class="form-control" :class="{'is-invalid': vErrors.first('headerCapable') }"
              name="headerCapable"
              v-model="standService.headerCapable"
              id="headerCapable"
              v-validate="'required'"
              data-vv-validate-on="blur">
              <option value="" disabled></option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('headerCapable') }}</span>
            </div>
          </div>
          <div class="form-group text-left">
            <label for="outletWithin6Feet">Outlet within 6ft</label>
            <select class="form-control" :class="{'is-invalid': vErrors.first('outletWithin6Feet') }"
              name="outletWithin6Feet"
              v-model="standService.outletWithin6Feet"
              id="outletWithin6Feet"
              v-validate="'required'"
              data-vv-validate-on="blur">
              <option value="" disabled></option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('outletWithin6Feet') }}</span>
            </div>
          </div>
          <div class="form-group text-left mb-3">
            <label for="canBeRelocated">Where can it be relocated near outlet</label>
            <textarea class="form-control"
                      id="canBeRelocated"
                      v-model="standService.canBeRelocated"
                      name="canBeRelocated"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      rows="3">
            </textarea>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors.first('canBeRelocated') && standService.outletWithin6Feet==='false'">
                <span>{{ vErrors.first('canBeRelocated') }}</span>
            </div>
          </div>
        </div>
        <div class="text-center">
          <base-button :disabled="disableSubmitButton" v-if="showSubmitButton() && !isJobActionCopleted(1)" type="primary" @click="standServiceSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import camera from './Camera'
import signatures from './Signatures'
export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null,
      showErrorPicturesAfter: false,
      showErrorPicturesBefore: false,
      showErrorPicturesWideAngle: false,
      standService: {
        beforePictures: [],
        afterPictures: [],
        wideAnglePictures: [],
        emptyPockets: null,
        filledPockets: null,
        cleanedStand: null,
        serviceNotes: null,
        unableService: null,
        newDelivered: null,
        headerInstallation: null,
        headerCapable: this.$route.params.headerCapableDrivers,
        canBeRelocated: this.$route.params.canBeRelocated,
        outletWithin6Feet: this.$route.params.outletWithin6Feet
      }
    }
  },
  computed: {
    isTestFunctions () {
      return this.$store.state.driver.testFunctions
    }
  },
  props: {
    disableSubmitButton: {
      type: Boolean,
      default: false,
      description: 'Disable submit button'
    }
  },
  methods: {
    standServiceSend () {
      this.showErrorPicturesBefore = this.standService.beforePictures.length === 0
      this.showErrorPicturesAfter = this.standService.afterPictures.length === 0
      this.showErrorPicturesWideAngle = this.standService.wideAnglePictures.length === 0

      if (this.showErrorPicturesBefore || this.showErrorPicturesAfter || this.showErrorPicturesWideAngle) {
        return
      }

      this.$validator.validateAll({
        emptyPockets: this.standService.emptyPockets,
        filledPockets: this.standService.filledPockets,
        cleanedStand: this.standService.cleanedStand,
        headerCapable: this.standService.headerCapable,
        outletWithin6Feet: this.standService.outletWithin6Feet,
        canBeRelocated: function () {
          if (this.standService.outletWithin6Feet === 'false') {
            return this.standService.canBeRelocated
          }

          return true
        }.bind(this)()
      }).then(result => {
        if (result) {
          this.$emit('standServiceFormDataSend', this.standService)
        }
      })
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, jobsMixin, standsMixin],
  components: {
    camera,
    signatures
  }
}
</script>
<style>
</style>
